import Config from "../Config";
import Requisicao from "./RequisicaoService";

class EmpresaModalidadePagamentoService {
    static async listar(idEmpresa) {        
        return Requisicao.get(Config.urlBaseApi + 'empresa/modalidade-pagamento/' + idEmpresa);
    }     
}

export default EmpresaModalidadePagamentoService;